import { render } from "./CaseStudies.vue?vue&type=template&id=befe876a&scoped=true"
import script from "./CaseStudies.vue?vue&type=script&lang=js"
export * from "./CaseStudies.vue?vue&type=script&lang=js"

import "./CaseStudies.vue?vue&type=style&index=0&id=befe876a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-befe876a"]])

export default __exports__